<template>
  <bootstrap-modal v-if="show">
    <div
      slot="header"
      class="modal-header"
    >
      <button
        type="button"
        class="close modal__close-button"
        data-dismiss="modal"
        aria-label="Close"
        @click="$emit('modal-close')"
      >
        <span aria-hidden="true">×</span>
      </button>
      <h4
        v-if="!viewModel.GradReelVideoInfo.HasGradReelVideos"
        class="modal-title"
      >
        <contentful-text :item="getMotionProductContent('checkout-download-motion-product-modal-head')" />
      </h4>
      <h4
        v-if="viewModel.GradReelVideoInfo.HasGradReelVideos"
        class="modal-title"
      >
        Your GradReel Story
      </h4>
    </div>
    <div
      slot="body"
      class="modal-body"
    >
      <div
        v-if="!isGifProduct && !viewModel.GradReelVideoInfo.HasGradReelVideos"
        class="idm-player"
      />

      <video
        v-if="viewModel.GradReelVideoInfo.HasGradReelVideos"
        id="studentVideoPlayer"
        ref="videoElement"
        :src="product.VideoURL"
        width="575"
        height="350"
        controls
      />

      <img
        v-if="isGifProduct"
        :src="product.VideoURL"
        class="motion-product-modal__gif-preview"
      >
      <div class="center">
        <div>
          <a
            :href="product.VideoURL"
            class="button"
            download
            target="_blank"
          >
            <contentful-text :item="getMotionProductContent('checkout-download-motion-product-download-button-label')" />
          </a>
        </div>
        <div class="motion-product-modal__download-instructions">
          <contentful-text :item="contentfulText('checkout-download-motion-product-download-instructions')" />
        </div>
      </div>
      <div
        v-if="fbShareSuccess !== null"
        :class="fbShareResultClasses"
      >
        <contentful-text
          v-if="fbShareSuccess"
          :item="getMotionProductContent('checkout-download-motion-product-share-success-message')"
        />
        <contentful-text
          v-if="!fbShareSuccess"
          :item="getMotionProductContent('checkout-download-motion-product-share-fail-message')"
        />
      </div>
      <div
        v-if="twitterShareSuccess !== null"
        :class="twitterShareResultClasses"
      >
        <contentful-text :item="getMotionProductContent('checkout-download-motion-product-twitter-share-complete')" />
      </div>
      <div
        v-if="!viewModel.GradReelVideoInfo.HasGradReelVideos"
        class="row row--mt-20"
      >
        <div class="col-xs-6 motion-product-modal__fb-share-column">
          <a
            :title="contentfulText('checkout-download-facebook-icon-hover-tooltip').Content"
            href="#"
            class="motion-product-modal__share-link"
            @click.prevent="handleFacebookShareClick"
          >
            <img
              :src="fbLogoImgPath"
              :alt="contentfulText('checkout-download-facebook-icon-hover-tooltip').Content"
              :title="contentfulText('checkout-download-facebook-icon-hover-tooltip').Content"
              class="motion-product-modal__share-icon"
            >
          </a>
        </div>
        <div class="col-xs-6">
          <a
            :title="contentfulText('checkout-download-twitter-icon-hover-tooltip').Content"
            href="#"
            class="share-link"
            @click.prevent="handleTwitterShareClick"
          >
            <img
              :src="twitterLogoImgPath"
              :alt="contentfulText('checkout-download-twitter-icon-hover-tooltip').Content"
              :title="contentfulText('checkout-download-twitter-icon-hover-tooltip').Content"
              class="motion-product-modal__share-icon js-twitter-share"
            >
          </a>
        </div>
      </div>
    </div>
  </bootstrap-modal>
</template>

<script>
import BootstrapModal from '@Shared/components/BootstrapModal'
import GoogleAnalytics from '@Shared/lib/google-analytics'
import motionProductMixin from './mixin'

export default {
  name: 'MotionProductModal',
  components: {
    BootstrapModal
  },
  mixins: [
    motionProductMixin
  ],
  props: {
    show: { type: Boolean, default: false, required: true },
    product: { type: Object, default: null, required: true }
  },
  data () {
    return {
      fbShareSuccess: null,
      twitterShareSuccess: null
    }
  },
  computed: {
    siteRoot () {
      return this.$store.state.siteRoot
    },
    viewModel () {
      return this.$store.state.viewModel
    },
    fbLogoImgPath () {
      return `${this.siteRoot}assets/responsive/shared/img/facebook.png`
    },
    twitterLogoImgPath () {
      return `${this.siteRoot}assets/responsive/shared/img/twitter.png`
    },
    fbShareResultClasses () {
      return {
        'motion-product-modal__share-result-msg': true,
        'alert': true,
        'alert-success': this.fbShareSuccess === true,
        'alert-danger': this.fbShareSuccess === false
      }
    },
    twitterShareResultClasses () {
      return {
        'motion-product-modal__share-result-msg': true,
        'alert': true,
        'alert-success': this.twitterShareSuccess === true,
        'alert-danger': this.twitterShareSuccess === false
      }
    },
    content () {
      return this.viewModel.PageContent
    }
  },
  watch: {
    show (v, ov) {
      if (v === true) {
        this.$nextTick(() => {
          if (!this.product.VideoURL.endsWith('.gif')) {
            this.$idomooPlayer.init({
              domain: 'https://idoplayer.idomoo.com/17/',
              url: this.product.VideoURL,
              autostart: 0,
              ga: this.viewModel.GoogleAnalyticsID,
              imgOptions: {
                openingImage: { imageURL: this.product.ThumbURL },
                closingImage: { imageURL: this.product.ThumbURL }
              },
              roa: true,
              css: `https://gradimages.com/assets/responsive/gradimages/css/idomooplayer.css`
            })
          }
        })
      }
    },
    fbShareSuccess (v, ov) {
      if (v !== null) {
        setTimeout(() => { this.fbShareSuccess = null }, 3000)
      }
    },
    twitterShareSuccess (v, ov) {
      if (v !== null) {
        setTimeout(() => { this.twitterShareSuccess = null }, 3000)
      }
    }
  },
  methods: {
    handleFacebookShareClick () {
      GoogleAnalytics.trackEvent(
        'Fulfillment.ShareMotionVideoOnFacebook',
        this.viewModel.CustomerRef,
        this.viewModel.ShareURL
      )

      this.$fB.ui(
        {
          href: this.viewModel.ShareURL,
          method: 'share',
          mobile_iframe: true
        },
        response => {
          if (response && !response.error_code) {
            this.fbShareSuccess = true
          } else {
            this.fbShareSuccess = false
          }
        }
      )
    },
    handleTwitterShareClick () {
      GoogleAnalytics.trackEvent(
        'Fulfillment.ShareMotionVideoOnTwitter',
        this.viewModel.CustomerRef,
        this.viewModel.ShareURL
      )
      if (this.viewModel.GradReelVideoInfo.HasGradReelVideos) {
        this.viewModel.ShareURL = this.viewModel.GradReelVideoInfo.VideoURL
      }
      const url = `https://twitter.com/intent/tweet?url=${this.viewModel.ShareURL}&text=${this.getMotionProductContent('checkout-download-motion-product-twitter-lede').Content}`
      const features = 'height=462,width=511'
      const twitterShareWindow = window.open(url, 'wShareTwitter', features)

      if (window.focus) {
        twitterShareWindow.focus()
      }

      let timer = setInterval(() => {
        if (twitterShareWindow.closed) {
          clearInterval(timer)
          this.twitterShareSuccess = true // Twitter share success is always "true" at this point as no response is returned from the remote window indicating success/fail
        }
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
.motion-product-modal {
  &__gif-preview {
    margin-bottom: 10px;
  }

  &__download-instructions {
    color: #333;
    margin-top: 7px;
    padding: 12px;
    background-color: #eee;
    font-size: 10px;
  }

  &__fb-share-column {
    text-align: right;
  }

  &__share {
    &-link {
      display: inline-block;
    }

    &-icon {
      height: 50px;
      width: 50px !important;
    }

    &-result-msg {
      margin-top: 10px;
    }
  }
}

.row--mt-20 {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/grad-images/checkout-download/components/MotionProduct/MotionProductModal.vue